import { CardSkeleton } from "@components/common/skeleton-loading/card-skeleton";
import { GroupCard } from "@components/group-card/group-card";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { useAppSelector } from "@store/store-helper";

interface Props {
  /** List of all the available groups in the company */
  groups: FaroCoreApiTypes.GroupSummaryResponse[];
}

/**
 * Lists all the available groups in the company as cards.
 */
export function GroupsTiles({ groups }: Props): JSX.Element {
  const { isFetchingGroups } = useAppSelector(fetchingGroupsFlagsSelector);

  return (
    <VirtualizedGrid
      // The `key` here forces React to remount the grid whenever `groups` changes.
      // This ensures that the scroll position resets and the grid re-renders from the first item
      key={groups.length}
      items={groups}
      isLoading={isFetchingGroups}
      renderSkeletonItem={(i) => (
        <CardSkeleton key={`skeleton-group-${i}`} type="group" />
      )}
      renderItem={(group) => <GroupCard key={group.id} group={group} />}
    />
  );
}
